import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {CommonService} from "../common.service";

@Component({
    selector: 'app-facilitatorprogress',
    templateUrl: './facilitatorprogress.component.html',
    styleUrls: ['./facilitatorprogress.component.css']
})
export class FacilitatorprogressComponent implements OnInit {
    private facilitatorInfo;
    private campusInfo;
    private totalCampus: number = 0;
    masterApi;
    facilitatorsMerge = [];
    Allfacilitators = [];
    finalArray = {'dropped': [], 'below_benchmark': [], 'improved': [], 'steady': []};

    constructor(public commonService: CommonService, private router: Router) {
        this.campusInfo = this.commonService.getAuditInfo();
        this.campusInfo.forEach((value: any) => {
            this.totalCampus = this.totalCampus + value['facilitators'].length;
        });

        var abc = this.campusInfo.map(x => {
            return x.facilitators.map(y => {
                //console.log(y.audits);
                if (y.hasOwnProperty("audits")) {
                    return {
                        'name': y.name,
                        'audits': y.audits,
                        'audistLength': y.audits.length,
                        'lastAudits': y.audits[y.audits.length - 1].lastEditedOn
                    };
                } else {
                    return {'name': y.name, 'audits': '', 'audistLength': '', 'lastAudits': ''};
                }

            });
        });

        for (let i = 0; i < abc.length; i++) {
            this.facilitatorsMerge = this.facilitatorsMerge.concat(abc[i]);
            this.Allfacilitators.push(abc[i].sort(this.sort));
        }

        // console.log(this.facilitatorsMerge);
        //console.log(this.Allfacilitators);
        /**
         * sort array
         * @type {any}
         */
        this.facilitatorsMerge.sort(this.sort);
        //console.log(this.facilitatorsMerge);
        this.get_progress(this.facilitatorsMerge);
    }

    sort(a, b) {
        if (a.lastAudits < b.lastAudits) {
            return 1;
        }
        if (a.lastAudits > b.lastAudits) {
            return -1;
        }
        if (a.lastAudits == b.lastAudits) {
            return 0;
        }
    }

    ngOnInit() {
    }

    get_progress(facilitators) {
        let auditInfo = [];
        facilitators.forEach(function (facilitator: any, campusIndex: number) {
            if (facilitator.audistLength > 1) {
                let auditsArr = {'name': '', 'ratings': Array()};
                let auditValue = Array();
                let fcLength = facilitator.audistLength;
                auditsArr['name'] = facilitator.name;
                for (let i = fcLength - 4; i <= fcLength; i++) {

                    if (!(typeof facilitator.audits[i] === 'undefined')) {
                        auditValue.push(this.get_rating(facilitator.audits[i].auditData))
                    }
                }
                auditsArr['ratings'] = auditValue;
                auditInfo.push(auditsArr)
            }

        }.bind(this))
        console.log(auditInfo);
        auditInfo.forEach(function (value: any, key: number) {
            var ratingsLength = value.ratings.length;
            /**
             * drop condition start
             */
            for (let i = 1; i < ratingsLength; i++) {
                if (value.ratings[ratingsLength - (i + 1)]['number'] != value.ratings[ratingsLength - i]['number']) {
                    if ((value.ratings[ratingsLength - (i + 1)]['number'] > value.ratings[ratingsLength - i]['number']) && (value.ratings[ratingsLength - (i + 1)]['number'] - value.ratings[ratingsLength - i]['number']) >= 2.2) {
                        this.finalArray['dropped'].push(value);
                    } else {
                        break;
                    }
                } else {
                    continue;
                }
            }
            /**
             * drop condition end
             */

            /**
             * Facilitators falling consistently below benchmark –
             start
             */
            var benchmark = 0, counter = 0;
            for (let i = 0; i < ratingsLength; i++) {
                if (value.ratings[i]['number'] <= benchmark) {
                    counter++;
                }
            }
            if (counter >= 2) {
                this.finalArray['below_benchmark'].push(value);
            }
            /**
             * Facilitators falling consistently below benchmark –
             end
             */

            /**
             * Facilitators who have improved start
             */
            for (let i = 1; i < ratingsLength; i++) {
                if ((value.ratings[ratingsLength - (i + 1)]['number'] < value.ratings[ratingsLength - i]['number']) && (value.ratings[ratingsLength - i]['number'] - value.ratings[ratingsLength - (i + 1)]['number']) >= 2.2) {
                    this.finalArray['improved'].push(value);
                } else {
                    break;
                }
            }
            /**
             * Facilitators who have improved end
             */

            /**
             * Facilitators falling consistently below benchmark –
             start
             */
            var passed = 0, counterSteady = 0;
            for (let i = 1; i < ratingsLength; i++) {
                if (value.ratings[i]['number'] > passed) {
                    if ((value.ratings[ratingsLength - (i + 1)]['number'] - value.ratings[ratingsLength - i]['number']) < 2.2) {
                        counterSteady++;
                    }
                }
            }
            if (counterSteady == 4) {
                this.finalArray['steady'].push(value);
            }
            /**
             * Facilitators falling consistently below benchmark –
             end
             */


        }.bind(this));

        console.log(this.finalArray);
    }

    get_rating(audits) {
        let arr = Array();
        let count: number = 0;
        for (let i = 1; i <= 6; i++) {
            if (audits['dim00' + i] == 1) {
                arr['color'] = "red";
                arr['number'] = 0;
                return arr;
            } else {
                if (audits['dim00' + i] == 2) {
                    count = count + 1;
                }
                if (audits['dim00' + i] == 3) {
                    count = count + 3;
                }
            }
        }
        //console.log((count/1.8).toFixed(1));
        var numb = parseFloat((count / 1.8).toFixed(1));
        if (numb == 10) {
            arr['color'] = "green";
        } else {
            arr['color'] = "yellow";
        }
        arr['number'] = numb;
        return arr;
    }
}



// WEBPACK FOOTER //
// /var/www/illumine/desktop/src/app/facilitatorprogress/facilitatorprogress.component.ts